export var DEFAULT_PAGE = 1;
export var DEFAULT_PAGE_SIZE = 5;
export var DEFAULT_SORT_BY = "AGE_OLDEST_FIRST";
export var DEFAULT_SORT_ORDER = "DESC";
export var DECAGON_SCRIPT_URL = "https://decagon.ai/loaders/faire.js";